import Notifications from './Notifications';
import NotificationsContainer from './Notifications.container';
import Notification from './Notification';
import * as actions from './redux/actionCreators';
import reducer from './redux/reducer';
export default NotificationsContainer(Notifications);
export { actions, reducer, Notification };
export * from './redux/types';

//# sourceMappingURL=index.js.map